module.exports = __webpack_public_path__ + "media/legacy/components/MainSection/top-left-decorator-06ac5d1dd7581a542b2c5c9c641dffa3.png";